export default "__VITE_ASSET__D5HMHYAS__"